<template src="./References.html" />

<script>
import Analytics from '../../mixins/Analytics';

export default {
  name: "References",
  props: ['refsState'],
  mixins: [Analytics]
}
</script>

<style scoped lang="scss" src="./References.scss" />
